import { isEmpty } from 'lodash'
import TextField from 'src/components/form/text-field/index.vue'
import { computed } from 'vue'

export default {
  components: {
    TextField
  },

  props:{
    errors: {
      type: Object,
      default: {}
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  setup(props, {emit}){

    const partNumber = computed({
      get: () => props.modelValue,
      set: value => emit('update:modelValue', value)
    })
    
    const updatePartNumber = () => {
      if (!Object.hasOwn(props.errors, 'part number') && !isEmpty(partNumber.value)) {
        emit('blur', partNumber.value)
      }
    }

    return {
      props,
      partNumber,
      updatePartNumber
    }
  }
}
